import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { customerInterface } from './customer';

const allowedTypes = new Set([
	'string',
	'number',
	'money',
	'date',
	'period-date',
	'select',
	'select-iac',
	'iac',
	'boolean',
	'checkbox',
	'time',
	'textarea',
	'attachment',
	'multi-select',
	'multi-input',
	'radio',
	'item',
	'selectable-list',
]);

export class genericFormI<
	inputType extends
		| 'string'
		| 'number'
		| 'money'
		| 'date'
		| 'time'
		| 'datetime'
		| 'period-date'
		| 'select'
		| 'select-iac'
		| 'iac'
		| 'boolean'
		| 'checkbox'
		| 'textarea'
		| 'attachment'
		| 'multi-select'
		| 'multi-input'
		| 'radio'
		| 'cronjob'
		| 'item'
		| 'selectable-list' = any,
> {
	inputType: inputType;
	id: string;
	label: string;
	name: string;
	//pseudoNames are alias by type while alias are just a second name
	alias?: string;
	pseudoNames?: { [key: string]: string };
	values: any[];
	/**
	 * Quando o values reccebe um objeto e não um tipo simples, o rawValues é responsável por segurar apenas o valor do id
	 * para facilitar o desenvolvedor de gerar um body. Ex:. values: [{"name":"Exemple", "label":"Example", "values":"001"}] => rawValues = ["001"]
	 */
	rawValues: any[];
	/**
	 * Quando um precisa ter a exibição formatada. Ex:. values: [{"name":"Exemple", "label":"Example", "values":"001"}, {"name":"Exemple", "label":"Example", "values":"002}] => stringfiendValue = Example 001, Example 002.
	 * esse valor não é convertido automaticamente, é só uma variável reservada pra guardar o valor formatado sem alterar a base do valor.
	 */
	invalidValue?: boolean;
	stringifiedValue?: string;
	hidden?: boolean;
	rawHidden?: boolean;
	disabled?: boolean;
	rawDisabled?: boolean;
	selected?: boolean;
	/**
	 * Chamados com customfields.required == 2 tem preenchimento obrigatório no encerramento do chamado somente.
	 */
	rawRequired?: boolean | 0 | 1 | 2;
	required?: boolean | 0 | 1 | 2;
	/**
	 * O campo rawInputType serve para armazenar o tipo do campo como uma constante caso seja necessário fazer algum manejo e retorno caso a ação seja cancelada, tipo alterar para tipo texto quando ele estiver bloqueado e select quando for pra ser funcional
	 */
	rawInputType?: inputType;
	qryInputType?: 'int' | 'varchar';
	analystView?: boolean;
	undeletable?: boolean;
	unchangeable?: boolean;
	instaSelect?: boolean;
	regex?: string;
	size?: number;
	tip?: string;
	hasDynamicTip?: boolean;
	isLoading?: boolean;
	ignoredInCustomer?: string[];
	/**
	 * O campo alert serve de controle caso submeta um value vazio com um campo required true.
	 */
	alert?: boolean | number;
	operator?: string;
	commonGroup?: string;

	extraFunction?: Function;
	tipFunction?: Function;
	onClickDisabled?: Function;

	//AutoWrite, preencher outros campos do formulário usando esse campo
	autoWriteFields?: any;
	autoWriteScript?: string;
	autoWrite?: boolean;

	//TIPO SELECT,
	//TIPO SELECT-IAC,
	//TIPO MONEY,
	//TIPO MULTI-INPUT,
	//TIPO MULTI-SELECT,
	//TIPO RADIO,
	//TIPO ATTACHMENT
	/**
	 * O array de itens recebe um genericFormI do tipo item ou do tipo any, as informações mandatórias são ID, Name, Label, Valor e inputType.
	 */
	items?: inputType extends
		| 'select'
		| 'select-iac'
		| 'money'
		| 'multi-input'
		| 'multi-select'
		| 'radio'
		| 'attachment'
		| 'selectable-list'
		? any
		: never; //genericFormInterface e iacOptionInterface para input-with-autocomplete (type 'iac')
	/**
	 * O outItems é a variável responsável por segurar os valores durante um filtro ou quando um valor pode ser manipulado como selecionado ou não selecionado.
	 */
	outItems?: inputType extends
		| 'select'
		| 'select-iac'
		| 'money'
		| 'multi-input'
		| 'multi-select'
		| 'radio'
		| 'attachment'
		| 'selectable-list'
		? any
		: never;
	_performActionAddItemWithParams? = (id: string, name: string, label: string, value?: string, inputType?: inputType) => {
		const newItem: genericFormI = new genericFormI(inputType ? inputType : 'item');
		newItem.id = id;
		newItem.label = label;
		newItem.name = name;
		newItem.values = [value ? value : id];
		newItem.rawValues = [value ? value : id];
		this.items.push(newItem);
	};

	_performActionAddItemWithObject? = (genericFormItem: genericFormI<any>) => {
		this.items.push(genericFormItem);
	};

	/** @type {((genericFormItem: genericFormI) => void) | ((id: string, name: string, label: string, value?: string, inputType?: inputType) => void))} */
	addItem?(genericFormItem: genericFormI<'item'>): void;
	addItem?(id: string, name: string, label: string, value?: string, inputType?: inputType): void;
	addItem?(
		parameter1: genericFormI<'item'> | string,
		parameter2?: string,
		parameter3?: string,
		parameter4?: string,
		parameter5?: inputType
	): void {
		if (
			typeof parameter1 === 'string' &&
			parameter2 !== undefined &&
			parameter3 !== undefined &&
			parameter4 !== undefined &&
			parameter5 !== undefined
		) {
			this._performActionAddItemWithParams(parameter1, parameter2, parameter3, parameter4, parameter5);
		} else if (typeof parameter1 === 'object' && parameter1 !== null) {
			this._performActionAddItemWithObject(parameter1);
		} else {
			throw new Error('Invalid arguments');
		}
	}

	removeItem?(index: number) {
		this.items.splice(index, 1);
	}

	//TIPO SELECT-IAC
	allowFreeText?: inputType extends 'select-iac' ? boolean : never; //Permitir que o campo deixe escrever o valor que quiser ou apenas items válidos da listagem

	//TIPO SELECT
	//TIPO SELECT-IAC
	hideUndefined?: inputType extends 'select' | 'select-iac' ? boolean : never; //Para esconder o valor indefinido, tipo o 'SELECIONE' nos campos selects;
	subSelect?: inputType extends 'select' | 'select-iac'
		? {
				//subSelect, carregar informações em outros campos (selects) usando esse campo
				subSelectChildName: string;
				subSelectQryName: string;
				parameters?: string[];
				when_value_is?: string[];
				make_required?: boolean;
			}[]
		: never;

	//TIPO MULTI-INPUT
	beforeAdd?: inputType extends 'multi-input' ? Function : never;
	afterAdd?: inputType extends 'multi-input' ? Function : never;
	beforeRemove?: inputType extends 'multi-input' ? Function : never;
	/**
	 * Esconde a box de valores do multi input caso você queira exibir de outra forma.
	 */
	hideMultiInputBox?: inputType extends 'multi-input' ? boolean : never;
	forceVertical?: inputType extends 'multi-input' ? boolean : never;
	allowEdit?: inputType extends 'multi-input' ? boolean : never;
	editingIndex?: inputType extends 'multi-input' ? number : never;
	alertIndex?: inputType extends 'multi-input' ? number : never;
	lastEditedItem?: inputType extends 'multi-input' ? number : never;
	multiInputLineId?: inputType extends 'multi-input' ? string[] : never;

	//TIPO MULTI-SELECT
	filterItem?: inputType extends 'multi-select' | 'selectable-list' ? string[] : never;
	boxHeight?: inputType extends 'multi-select' | 'selectable-list' ? number : never;

	focusItemIndex?: inputType extends 'multi-select' | 'selectable-list' ? number : never;
	focusValueIndex?: inputType extends 'multi-select' | 'selectable-list' ? number : never;

	isHeld?: inputType extends 'multi-select' | 'selectable-list' ? boolean : never;
	heldFirstIndex?: inputType extends 'multi-select' | 'selectable-list' ? number : never;
	heldLastIndex?: inputType extends 'multi-select' | 'selectable-list' ? number : never;
	focusSide?: inputType extends 'multi-select' | 'selectable-list' ? 'item' | 'value' : never;

	allowDragAndDrop?: inputType extends 'multi-select' | 'selectable-list' ? boolean : never;
	forceDragAndDrop?: inputType extends 'multi-select' | 'selectable-list' ? boolean : never;
	isDraggingItem?: inputType extends 'multi-select' | 'selectable-list' ? boolean : never;
	draggingIndex?: inputType extends 'multi-select' | 'selectable-list' ? number : never;
	draggingSource?: inputType extends 'multi-select' | 'selectable-list' ? 'items' | 'values' : never;
	dragPosition?: inputType extends 'multi-select' | 'selectable-list' ? { x: number; y: number } : never;
	draggingItem?: inputType extends 'multi-select' | 'selectable-list' ? genericFormI<'item'> : never;

	//TIPO MULTI-SELECT
	//TIPO MULTI-INPUT
	filterValues?: inputType extends 'multi-input' | 'multi-select' | 'selectable-list' ? string[] : never;

	//TIPO DATE
	periodType?: inputType extends 'date' ? string : never;

	//TIPO ATTACHMENT
	fileSource?: inputType extends 'attachment' ? 'request' | 'cmdb' | 'km' : never;

	//TIPO CRONJOB
	limitCron?: inputType extends 'cronjob' ? string[][] : never;

	//Específico apenas para integração com AD
	//Será descontinuado.
	adFunction?: Function;
	existInAd?: boolean;
	notExistInAd?: boolean;

	constructor(inputType: inputType) {
		if (!allowedTypes.has(inputType)) {
			throw `Invalid type (${inputType}) defined on genericForm`;
		}
		this.inputType = inputType;

		//Mandatory attributes for base genericForm
		this.id = '';
		this.label = '';
		this.name = '';
		this.values = [];
		this.rawValues = [];

		//Not mandatory attributes for base genericForm
		this.hidden = false;
		this.disabled = false;
		this.required = false;
		this.rawInputType = this.inputType;
		this.qryInputType = undefined;
		this.analystView = false;
		this.undeletable = false;
		this.unchangeable = false;
		this.instaSelect = false;
		this.regex = '';
		this.size = 0;
		this.tip = '';
		this.isLoading = false;
		this.alert = false;
		this.extraFunction = undefined;
		this.tipFunction = undefined;
		this.onClickDisabled = undefined;
		this.autoWriteFields = undefined;
		this.autoWriteScript = undefined;
		this.autoWrite = undefined;
		this.operator = undefined;

		if (this.inputType == 'string') {
			this.values[0] = '';
		}

		if (this.inputType == 'select') {
			this.items = <any>[];
			this.outItems = <any>[];
			this.hideUndefined = <any>false;
			this.subSelect = <any>[];
		}

		if (this.inputType == 'select-iac') {
			this.items = <any>[];
			this.outItems = <any>[];

			this.hideUndefined = <any>false;
			this.subSelect = <any>[];
		}

		if (this.inputType == 'multi-input') {
			this.items = <any>[];
			this.outItems = <any>[];

			this.beforeAdd = undefined;
			this.afterAdd = undefined;
			this.beforeRemove = undefined;
			this.hideMultiInputBox = <any>false;
			this.forceVertical = <any>false;
			this.allowEdit = <any>false;
			this.editingIndex = undefined;
			this.alertIndex = undefined;
			this.lastEditedItem = undefined;
			this.multiInputLineId = <any>[];

			this.filterValues = <any>[];
		}

		if (this.inputType == 'multi-select' || this.inputType == 'selectable-list') {
			this.items = <any>[];
			this.filterItem = <any>[];
			this.filterValues = <any>[];
			this.isHeld = <any>false;
			this.focusSide = undefined;
			this.allowDragAndDrop = <any>false;
			this.isDraggingItem = <any>false;
			this.draggingIndex = undefined;
			this.draggingItem = undefined;
			this.draggingSource = undefined;
			this.dragPosition = <any>{ x: 0, y: 0 };
		}

		if (this.inputType == 'attachment') {
			this.items = <any>[];
			this.fileSource = undefined;
		}

		if (this.inputType == 'money') {
			this.items = <any>[];
			this.values[0] = '';
		}

		if (this.inputType == 'radio') {
			this.items = <any>[];
		}

		if (this.inputType == 'cronjob') {
			this.values = ['*', '*', '*', '*', '*'];
			this.rawValues = ['*', '*', '*', '*', '*'];
		}

		if (this.inputType == 'date') {
			this.periodType = <any>'period';
		}
	}

	//Variável de controle para agrupar inputs se desejado
	// commonGroup? : string;
	// email?:any;
	// hideIndex?: number[];
	// subfield_items?: string[];
	// ignoredInCustomer?: customerInterface[],
}
